import React from 'react'
import { useSelector } from 'react-redux'
import { EntityType } from 'api'
import { Locale, Translation } from 'locale'
import { noop } from 'lodash'
import { IndexDialogComponent } from './IndexDialogComponent'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { isNotNil } from 'utils/predicate'

export interface IndexEditDialogProps {
  entityId: string
  onClose?: () => unknown
}

export const IndexViewDialog: React.FC<IndexEditDialogProps> = ({ entityId, onClose = noop }) => {
  const index = useSelector(createEntityGetterSelector(EntityType.INDEX))(entityId)

  return isNotNil(index) ? (
    <IndexDialogComponent
      title={Locale.translate(Translation.TC_VIEW_INDEX)}
      readOnly={true}
      index={index}
      validationIssues={[]}
      onClose={onClose}
      onSave={noop}
      onUpdate={noop}
    />
  ) : null
}
